module.exports = __webpack_public_path__ + "img/40_85.9f320cc5.png";